import React, { useState, useEffect, useRef } from 'react';
import { Analytics } from '@vercel/analytics/react';
import PricingPage from './PricingPage';
import FemalePricingPage from './FemalePricingPage';
import { wallOfWinsRow1, wallOfWinsRow2, videoTestimonials, BUNNY_LIBRARY_ID, BUNNY_VSL_VIDEO_ID } from './winsData';
import { db, auth, APP_ID } from './firebase';
import { submitLead, retryPendingLeads } from './submitLead';
import {
  collection,
  onSnapshot,
  doc,
  deleteDoc,
  updateDoc,
  DocumentData
} from "firebase/firestore";
import {
  onAuthStateChanged,
  signInWithPopup,
  signOut,
  GoogleAuthProvider,
  User
} from "firebase/auth";
import { 
  ChevronRight, 
  ChevronLeft,
  Activity, 
  ArrowRight, 
  ArrowDown,
  CheckCircle2, 
  Target, 
  Heart, 
  Lock,
  Star,
  Clock, 
  ShieldCheck, 
  Utensils,
  Users,
  Scale, 
  Brain,
  Coffee,
  CalendarCheck,
  Search,
  Battery,
  X,
  Wallet,
  TrendingDown,
  Banknote,
  Youtube,
  Frown,
  AlertCircle,
  ChevronDown,
  LayoutDashboard,
  Phone,
  Trash2,
  Eye,
  Sparkles,
  Zap,
  TrendingUp,
  Receipt,
  Calendar,
  Home,
  Flame,
  ShoppingCart
} from 'lucide-react';
import MounjaroCounter from './MounjaroCounter';
import BunnyVideo from './BunnyVideo';

// ==========================================
// GOOGLE REVIEWS DATA & COMPONENT
// ==========================================
const googleReviewsData = [
  { name: "Farwa Jaffer", initial: "F", bgColor: "bg-slate-600", isLocalGuide: true, subtitle: "Local Guide • 24 reviews", text: "I joined Zaybs 1-2-1 in May this year... I was 75kgs, unhealthy, unfit, unhappy, mentally down, used to crave sugar and was always lethargic. I have PCOS and felt like I had no control. Within a month if joining, I felt empowered and motivated by the help Zayb gave me... I've lost 8 kg, several cms and bad skin along the way. Didn't ban me from eating my favourite foods." },
  { name: "Z I", initial: "Z", bgColor: "bg-blue-500", isLocalGuide: false, subtitle: "4 reviews", text: "Leaving this review incredibly late, but just wanted to share my experience! Zayb and his team were absolutely incredible and helped lose so much weight and reduce my inches, I never felt more confident, empowered and free with my meals and food, could still enjoy my Starbucks, date night without feeling restricted... what Zayb teaches lasts a lifetime." },
  { name: "Miriam Khan", initial: "M", bgColor: "bg-teal-600", isLocalGuide: false, subtitle: "4 reviews", text: "I have joined ZA training membership 2 months ago. I regret not joining earlier! Its a one stop shop for reaching your weightloss goals. There is heaps of information on the website... After my check in every week, I am given feedback which is helpful for the progression... and the best thing is you dont need to give up the food you enjoy!" },
  { name: "Asma Chothia", initial: "A", bgColor: "bg-indigo-500", isLocalGuide: false, subtitle: "3 reviews", text: "I joined with zayb in August last year and wow is the only word I can use to describe everything he and his team put in place to make life so much easier... the help and guidance zayb gives is second to none and he is always at hand to make sure that you are ok... Go for it it will be the best decision you ever make in your life!!" },
  { name: "Nayab Hussain", initial: "N", bgColor: "bg-slate-800", isLocalGuide: false, subtitle: "4 reviews", text: "I have done nutritional training with other professionals before but never come across someone with so much knowledge and the quality of the training is amazing... I have really enjoyed changing my lifestyle through good foods without having to eliminate all the sugar and junk." },
  { name: "Shabeena Khan", initial: "S", bgColor: "bg-amber-800", isLocalGuide: false, subtitle: "1 review", text: "ZA TRAINING!!!!! Where to start!!! Well one of the best things that I looooove about this wonderful team is that... there is still an incredible personal touch given to each individual. I feel listened to , cared for and my doubts and apprehensive-ness is put to bed literally straight away... I promise you it is the best decision that you will ever make." },
  { name: "Zaira", initial: "Z", bgColor: "bg-purple-500", isLocalGuide: false, subtitle: "2 reviews", text: "Great Program, the team is very supportive and help you stay focused and on track. I would definitely recommend this program, everything you learn can be applied long term not just while you are on the program. Zayb is great and keeps you accountable but also very supportive." },
  { name: "Rabiah Islam", initial: "R", bgColor: "bg-indigo-600", isLocalGuide: false, subtitle: "4 reviews", text: "Signed up couple months ago. Best decision. After I stopped, I did not gain weight but continued to keep it off as ZA TRAINING not only helps you with weight but equips you with great knowledge that is gold for life... Glad I found them and did this with them. Thanks!" },
  { name: "Sultana Khanom", initial: "S", bgColor: "bg-slate-700", isLocalGuide: false, subtitle: "1 review", text: "Fantastic place to lose weight as well as connect with the team. They cater for everyone and understand especially us mums and how it’s easy to fall off the wagon. Overall it’s the best place to join if you want to lose weight. Keep it up." },
  { name: "Zak Mulla", initial: "Z", bgColor: "bg-cyan-700", isLocalGuide: false, subtitle: "1 review", text: "Nothing has ever motivated me like this...if you want a lifestyle change and need help Z A training is the place for sure!" },
  { name: "Mahnoor Rasheed", initial: "M", bgColor: "bg-orange-600", isLocalGuide: true, subtitle: "Local Guide • 6 reviews", text: "I am currently a member of Z.A training and for the price the amount of information you get and support is awesome. I've tried so many fad diets in order to lose weight nothing worked. Zayd and his team help break down what you need to do and most importantly how to do it properly. It's an amazing team always there to support you and always there to give the best advice." }
];

const GoogleReviewCard = ({ review }: { review: any }) => (
  <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-slate-200 flex flex-col h-full hover:shadow-md transition-shadow break-inside-avoid">
    <div className="flex items-center justify-between mb-4">
      <div className="flex items-center gap-3">
        <div className={`w-11 h-11 ${review.bgColor} text-white rounded-full flex items-center justify-center font-bold text-lg relative`}>
          {review.initial}
          {review.isLocalGuide && (
            <div className="absolute -bottom-1 -right-1 bg-orange-500 rounded-full p-0.5 border-2 border-white">
              <Star className="w-2.5 h-2.5 text-white fill-current" />
            </div>
          )}
        </div>
        <div>
          <h4 className="font-bold text-slate-900 leading-tight">{review.name}</h4>
          <p className="text-xs text-slate-500">{review.subtitle}</p>
        </div>
      </div>
      <svg className="w-5 h-5 opacity-40 shrink-0" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
      </svg>
    </div>
    <div className="flex gap-1 text-yellow-400 mb-3">
      <Star className="h-4 w-4 fill-current" /><Star className="h-4 w-4 fill-current" /><Star className="h-4 w-4 fill-current" /><Star className="h-4 w-4 fill-current" /><Star className="h-4 w-4 fill-current" />
    </div>
    <p className="text-slate-700 text-sm leading-relaxed flex-grow">"{review.text}"</p>
  </div>
);

// ==========================================
// STATIC DATA: WALL OF WINS (real client screenshots)
// ==========================================

// ==========================================
// STATIC DATA: FEATURES, FAQS, TESTIMONIALS
// ==========================================
const faqs = [
  { q: "Do I have to cook separate 'diet' meals from my family?", a: "Absolutely not. The entire premise of this blueprint is integrating your cultural foods (curries, rice, rotis) into a structured plan so you eat what your family eats, just portioned correctly so the weight comes off steadily." },
  { q: "What if I have a crazy routine and have little to no time to myself?", a: "Then this was built for you. You will have a structure that's built specifically around your own routine. This is designed for the busy person" },
  { q: "How much support do I get?", a: "You are assigned a coach, me, who will check in with you daily. There are no groups or monthly calls. Every day you will have clarity and support. Which is why we only accept a few clients each month to ensure everyone is given my full support" },
  { q: "Do I need to join a gym?", a: "You can, but it's not essential. Your workouts will be designed around what you have access to. If it's a gym, awesome. If it's in your bedroom with one rusty dumbbell, that's perfect too." },
  { q: "Is this just another generic PDF plan?", a: "No. This is a high-touch, 1-on-1 premium coaching experience. I personally map out your nutrition, your routine, and check in with you to keep you on track and accountable to your goals." },
  { q: "I've tried and failed so many times. Why will this work?", a: "Because we aren't relying on extreme restriction or willpower. We are building a system around your actual life, your culture, and your habits. When the plan actually fits your lifestyle, consistency becomes effortless." },
  { q: "I'm currently on Mounjaro, Ozempic, or Wegovy — can I still join?", a: "Yes. Many of our clients are on GLP-1 medication. We build your nutrition and habits around your treatment, not against it — so you're set up to keep your results even after you come off it." }
];

interface Lead {
  id: string;
  name: string;
  phone: string;
  instagram?: string;
  gender?: string;
  createdAt: string;
  quizAnswers: Record<string, string>;
  status: string;
}

// Plain-English titles for the answers saved against a lead, so the dashboard
// reads like questions rather than internal field names.
const QUESTION_LABELS: Record<string, string> = {
  goal: 'Their main goal',
  barrier: "What's stopped them before",
  timeline: 'How soon they want results',
  reason: 'What brought them here',
  need: 'What they need right now',
  readiness: 'Ready to invest in themselves?',
};

const formatLeadDate = (value: string) => {
  const date = new Date(value);
  return isNaN(date.getTime())
    ? 'Date unknown'
    : date.toLocaleString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};

// ==========================================
// MAIN APPLICATION COMPONENT
// ==========================================
const ADMIN_EMAIL = 'info@zatraining.co.uk';

export default function App() {
  const [user, setUser] = useState<User | null>(null);
  const [showAdmin, setShowAdmin] = useState<boolean>(false);
  const [showPricing, setShowPricing] = useState<boolean>(false);
  const [showFemalePricing, setShowFemalePricing] = useState<boolean>(false);
  const [leads, setLeads] = useState<Lead[]>([]);
  const [selectedLead, setSelectedLead] = useState<Lead | null>(null);
  
  const [step, setStep] = useState<number>(0); 
  const [answers, setAnswers] = useState<Record<string, string>>({});
  const [name, setName] = useState<string>('');
  const [phone, setPhone] = useState<string>('');
  const [instagram, setInstagram] = useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [submitError, setSubmitError] = useState<boolean>(false);
  const [loadingText, setLoadingText] = useState<string>("Analyzing your answers...");
  const [selectedAnswer, setSelectedAnswer] = useState<string | null>(null);
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [weightGoal, setWeightGoal] = useState<number>(10);
  const [q1Selections, setQ1Selections] = useState<string[]>([]);
  const [q2Selections, setQ2Selections] = useState<string[]>([]);

  // Testimonials are a plain native horizontal scroll strip — no JS, no auto-movement. Native
  // scrolling is the browser's own swipe, so it can't break, and it never interferes with the
  // live video players, which keep their native play button (one tap plays them with sound).

  useEffect(() => {
    retryPendingLeads();
  }, []);

  // Auth & Admin Detect
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('admin')) setShowAdmin(true);
    if (urlParams.get('pricing') === 'female') setShowFemalePricing(true);
    else if (urlParams.has('pricing')) setShowPricing(true);
    const unsubscribe = onAuthStateChanged(auth, (u) => setUser(u));
    return () => unsubscribe();
  }, []);

  const isAdmin = !!user && user.email === ADMIN_EMAIL && user.emailVerified;
  const [dashboardError, setDashboardError] = useState<string>('');

  // Dashboard logic for Admin — only Zayb's signed-in account can read leads
  useEffect(() => {
    if (!isAdmin || !showAdmin) return;
    const leadsRef = collection(db, 'artifacts', APP_ID, 'public', 'data', 'leads');
    const unsubscribe = onSnapshot(leadsRef, (snapshot) => {
      setDashboardError('');
      const docs = snapshot.docs.map(docSnap => ({ id: docSnap.id, ...docSnap.data() } as Lead));
      setLeads(docs.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()));
    }, (error) => setDashboardError(error.message));
    return () => unsubscribe();
  }, [isAdmin, showAdmin]);


  const handleAnswer = (questionId: string, answer: string) => {
    setSelectedAnswer(answer); 
    
    setTimeout(() => {
      setAnswers(prev => ({ ...prev, [questionId]: answer }));

      // Disqualifying answers route straight to the polite exit (Step 99)
      if (answer.includes("PDF plan") || answer === "Not right now") {
        setStep(99);
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setSelectedAnswer(null);
        return;
      }

      // Step 3 is the final question -> go straight to capture form
      if (step === 3) {
        setStep(6);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        setStep(step + 1);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      setSelectedAnswer(null);
    }, 400); 
  };

  const finishApplication = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitError(false);
    const ok = await submitLead({ name, phone, instagram, answers });
    setIsSubmitting(false);
    if (!ok) {
      setSubmitError(true);
      return;
    }
    setStep(7);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const startQuiz = () => { window.scrollTo({ top: 0, behavior: 'smooth' }); setStep(1); };

  // Testimonial strip: slide to the next story card
  const showNextStory = (i: number) =>
    document.getElementById(`story-${i + 1}`)?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });

  const resetFunnel = () => {
    setStep(0);
    setAnswers({});
    setName('');
    setPhone('');
    setInstagram('');
    setQ1Selections([]);
    setQ2Selections([]);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // ==========================================
  // PRICING PAGE (private, ?pricing URL flag)
  // ==========================================
  if (showFemalePricing) return <FemalePricingPage />;
  if (showPricing) return <PricingPage />;

  // ==========================================
  // ADMIN DASHBOARD VIEW
  // ==========================================
  if (showAdmin && !isAdmin) {
    return (
      <div className="min-h-screen bg-slate-900 text-white p-6 font-sans flex items-center justify-center">
        <div className="w-full max-w-sm text-center bg-slate-800 border border-slate-700 rounded-3xl p-8">
          <LayoutDashboard className="text-red-600 mx-auto mb-4" size={36} />
          <h1 className="text-2xl font-black uppercase tracking-tighter mb-2">Lead Dashboard</h1>
          {user && !user.isAnonymous ? (
            <>
              <p className="text-slate-400 mb-6">{user.email} doesn't have access. Sign in with {ADMIN_EMAIL}.</p>
              <button onClick={() => signOut(auth)} className="w-full bg-slate-700 hover:bg-slate-600 py-3 rounded-xl font-bold transition-all">Sign out</button>
            </>
          ) : (
            <>
              <p className="text-slate-400 mb-6">Sign in with your Z.A Training Google account to see your leads.</p>
              <button onClick={() => signInWithPopup(auth, new GoogleAuthProvider()).catch((e) => setDashboardError(e.message))} className="w-full bg-white text-slate-900 hover:bg-slate-200 py-3 rounded-xl font-black transition-all">Sign in with Google</button>
            </>
          )}
          {dashboardError && <p className="text-red-400 text-sm mt-4">{dashboardError}</p>}
        </div>
      </div>
    );
  }

  if (showAdmin) {
    return (
      <div className="min-h-screen bg-slate-900 text-white p-6 font-sans flex flex-col items-center">
        <div className="w-full max-w-4xl">
          <div className="flex justify-between items-center mb-10">
            <h1 className="text-3xl font-black flex items-center gap-2 uppercase tracking-tighter">
              <LayoutDashboard className="text-red-600" /> Lead Dashboard ({leads.length})
            </h1>
            <div className="flex gap-2">
              <button onClick={() => signOut(auth)} className="bg-slate-800 px-6 py-2 rounded-xl font-bold hover:bg-slate-700 transition-all">Sign out</button>
              <button onClick={() => setShowAdmin(false)} className="bg-slate-800 px-6 py-2 rounded-xl font-bold hover:bg-slate-700 transition-all">Close</button>
            </div>
          </div>
          {dashboardError && <p className="bg-red-950 border border-red-800 text-red-300 rounded-xl p-4 mb-6">Couldn't load leads: {dashboardError}</p>}
          <div className="grid grid-cols-1 gap-4">
            {leads.map(lead => (
              <div key={lead.id} className="bg-slate-800 p-6 rounded-[30px] border border-slate-700 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 shadow-lg transition-all hover:border-red-600/50">
                <div className="text-left">
                  <h3 className="text-xl font-bold text-white uppercase">{String(lead.name)}</h3>
                  <div className="flex items-center gap-2 text-red-500 mt-1 font-mono tracking-tighter">
                    <Phone size={14} /> {String(lead.phone)}
                  </div>
                  <p className="text-slate-400 text-xs mt-2 font-semibold">
                    {formatLeadDate(lead.createdAt)}
                    {lead.gender === 'male' ? ' • Men\'s funnel' : ' • Women\'s funnel'}
                    {Object.keys(lead.quizAnswers || {}).length > 0
                      ? ` • ${Object.keys(lead.quizAnswers).length} answers`
                      : ' • no answers'}
                  </p>
                </div>
                <div className="flex gap-3">
                  <a href={`https://wa.me/${String(lead.phone).replace(/\D/g, '')}`} target="_blank" rel="noreferrer" className="px-4 py-3 bg-green-600 text-white font-bold rounded-2xl hover:bg-green-700 transition-all text-xs flex items-center gap-2">
                    WhatsApp
                  </a>
                  <button onClick={() => setSelectedLead(lead)} className="p-3 bg-slate-700 rounded-2xl hover:bg-slate-600"><Eye size={20} /></button>
                </div>
              </div>
            ))}
            {leads.length === 0 && <p className="text-center text-slate-500 font-bold py-10">No leads captured yet.</p>}
          </div>
        </div>

        {/* Lead Detail Modal */}
        {selectedLead && (
          <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm text-left">
            <div className="bg-white text-slate-900 w-full max-w-xl rounded-[40px] shadow-2xl p-8 max-h-[80vh] overflow-y-auto">
               <div className="flex justify-between mb-8">
                 <div>
                   <h2 className="text-3xl font-black uppercase tracking-tighter">{String(selectedLead.name)}</h2>
                   <p className="text-red-600 font-bold">{String(selectedLead.phone)}</p>
                   {selectedLead.instagram && <p className="text-blue-500 font-bold text-sm">@{String(selectedLead.instagram)}</p>}
                   <p className="text-slate-500 text-sm font-semibold mt-1">
                     {formatLeadDate(selectedLead.createdAt)}
                     {selectedLead.gender === 'male' ? ' • Men\'s funnel' : ' • Women\'s funnel'}
                   </p>
                 </div>
                 <button onClick={() => setSelectedLead(null)}><X size={24}/></button>
               </div>
               <div className="space-y-4">
                 {Object.entries(selectedLead.quizAnswers || {}).map(([q, a]) => (
                   <div key={q} className="bg-slate-50 p-4 rounded-2xl text-left">
                     <p className="text-[10px] font-black uppercase text-slate-400 mb-1">{QUESTION_LABELS[q] || q}</p>
                     <p className="font-bold text-slate-800">{String(a)}</p>
                   </div>
                 ))}
                 {Object.keys(selectedLead.quizAnswers || {}).length === 0 && (
                   <p className="bg-slate-50 p-4 rounded-2xl text-slate-500 font-bold text-sm">
                     They didn't answer any questions — this one came straight from a form.
                   </p>
                 )}
                 <a
                   href={`https://wa.me/${String(selectedLead.phone).replace(/\D/g, '')}`}
                   target="_blank"
                   rel="noreferrer"
                   className="block w-full bg-green-600 hover:bg-green-700 text-white text-center font-black py-4 rounded-2xl transition-all uppercase tracking-wider"
                 >
                   Message on WhatsApp
                 </a>
               </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  // ==========================================
  // FUNNEL VIEWS
  // ==========================================
  return (
    <div className="min-h-screen bg-white font-sans text-zinc-900 flex flex-col overflow-x-hidden">
      
      <style dangerouslySetInnerHTML={{__html: `
        .hide-scrollbar::-webkit-scrollbar { display: none; }
        .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
        @keyframes shimmer {
          100% { transform: translateX(100%); }
        }
        @keyframes marquee-left { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
        @keyframes marquee-right { 0% { transform: translateX(-50%); } 100% { transform: translateX(0); } }
        .animate-marquee-left { display: flex; width: fit-content; animation: marquee-left 55s linear infinite; }
        .animate-marquee-right { display: flex; width: fit-content; animation: marquee-right 65s linear infinite; }
        .marquee-row:hover .animate-marquee-left, .marquee-row:hover .animate-marquee-right { animation-play-state: paused; }
        @keyframes swipe-indicator {
          0%, 100% { transform: translateX(0); }
          50% { transform: translateX(4px); }
        }
        .animate-swipe-indicator { animation: swipe-indicator 1.5s ease-in-out infinite; }
      `}} />

      {/* HEADER WITH LOGO (Hidden on Success step) */}
      {step < 7 && step !== 99 && (
        <header className="bg-white border-b border-zinc-200 sticky top-0 z-50 shadow-md w-full">
          <div className="flex justify-center items-center py-4 bg-white border-b border-zinc-200">
            <img 
              src="https://firebasestorage.googleapis.com/v0/b/accountability-566c2.firebasestorage.app/o/088529ce-52f4-4ef7-a65f-0923d5901386.png?alt=media" 
              alt="Z.A Training Logo" 
              className="h-12 md:h-16 object-contain"
              onError={(e) => { e.currentTarget.style.display = 'none'; }}
            />
          </div>
        </header>
      )}

      <main className="flex-grow flex flex-col items-center">
        
        {/* ==========================================
            STEP 0: LONG-FORM LANDING PAGE
            ========================================== */}
        {step === 0 && (
          <div className="w-full animate-in fade-in duration-700 pb-20 md:pb-0">
            
            <section className="w-full max-w-5xl mx-auto px-4 pt-12 pb-16 text-center">
              <div className="flex items-center justify-center gap-3 mb-8">
                <span className="hidden sm:block h-px w-10 bg-zinc-300"></span>
                <p className="flex items-center gap-2 text-zinc-600 text-[11px] md:text-xs font-semibold uppercase tracking-[0.2em]">
                  <span className="text-amber-500 text-sm">★★★★★</span>
                  Trusted by 1000+ South Asians
                </p>
                <span className="hidden sm:block h-px w-10 bg-zinc-300"></span>
              </div>
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold leading-tight text-zinc-950 mb-6 tracking-tight">
                Predictable weight loss for <br className="hidden md:block"/>
                <span className="text-red-600">South Asian Women</span>
              </h1>
              <p className="text-xl md:text-3xl text-zinc-800 max-w-3xl mx-auto leading-relaxed mb-8 font-bold">
                Costs less than{' '}
                <span className="text-red-600 underline decoration-wavy decoration-red-700 underline-offset-4">Mounjaro</span>
                . Works longer than{' '}
                <span className="text-red-600 underline decoration-wavy decoration-red-700 underline-offset-4">Mounjaro</span>
                .
              </p>

              <button
                onClick={() => document.getElementById('glp1-faq')?.scrollIntoView({ behavior: 'smooth' })}
                className="inline-flex items-center gap-2 bg-white border-2 border-zinc-900 hover:border-red-600 text-zinc-900 text-xs md:text-sm font-bold px-5 py-2.5 rounded-full mb-8 transition-colors shadow-sm"
              >
                💉 Already on Mounjaro or Ozempic? We work with that too →
              </button>

              {/* TOP-LINE CREDIBILITY STATS */}
              <div className="flex flex-wrap justify-center gap-10 md:gap-20 py-6 mb-4">
                <div className="text-center">
                  <h4 className="text-4xl md:text-5xl font-black mb-1 text-zinc-950">500+</h4>
                  <p className="text-[11px] md:text-xs font-bold text-zinc-600 uppercase tracking-widest">Women Transformed</p>
                </div>
              </div>

              <div className="flex justify-center px-2 mb-4">
                <div className="inline-flex items-center gap-4 bg-zinc-100 border border-zinc-200 rounded-full pl-3 pr-6 py-2.5 max-[379px]:flex-col max-[379px]:gap-2 max-[379px]:rounded-3xl max-[379px]:px-5 max-[379px]:py-3">
                  <div className="flex -space-x-3 shrink-0">
                    {['avatar-1', 'avatar-2', 'avatar-3', 'avatar-4', 'avatar-5', 'avatar-6'].map((a, i) => (
                      <img
                        key={i}
                        src={`/avatars/${a}.jpg`}
                        alt="Client"
                        className="w-9 h-9 rounded-full object-cover border-2 border-white"
                      />
                    ))}
                  </div>
                  <p className="text-zinc-700 text-sm md:text-base font-semibold max-[379px]:text-center">Trusted by 1000+ South Asians</p>
                </div>
              </div>

              {/* FEATURED TESTIMONIAL VIDEO — bigger than the strip below, so it stands out */}
              <div className="flex flex-col items-center justify-center mt-8 mb-8">
                <p className="text-center mb-6 max-w-xs leading-[2.4rem]">
                  <span className="inline-block bg-yellow-300 text-black text-xl md:text-2xl font-black px-2 -rotate-1" style={{ boxShadow: '2px 2px 0 rgba(0,0,0,0.2)' }}>
                    Speak to Zayb.
                  </span>
                  <br />
                  <span className="inline-block bg-yellow-300 text-black text-xl md:text-2xl font-black px-2 rotate-1" style={{ boxShadow: '2px 2px 0 rgba(0,0,0,0.2)' }}>
                    He will sort everything
                  </span>
                  <br />
                  <span className="inline-block bg-yellow-300 text-black text-xl md:text-2xl font-black px-2 -rotate-1" style={{ boxShadow: '2px 2px 0 rgba(0,0,0,0.2)' }}>
                    out for you.
                  </span>
                </p>
                <div className="w-full max-w-sm rounded-3xl overflow-hidden border-2 border-red-700 shadow-[0_30px_60px_-10px_rgba(220,38,38,0.4)]">
                  <div className="aspect-[9/16] bg-black">
                    <BunnyVideo
                      libraryId={BUNNY_LIBRARY_ID}
                      videoId={videoTestimonials[0].bunnyId}
                      title="Noreen's Story"
                      onCta={startQuiz}
                    />
                  </div>
                </div>
              </div>

              <div className="flex flex-col items-center justify-center gap-3 mt-2 mb-4">
                <button
                  onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); setStep(1); }}
                  className="group relative bg-red-700 hover:bg-red-800 text-white text-xl md:text-2xl font-black py-6 px-12 rounded-md shadow-[0_10px_25px_-5px_rgba(185,28,28,0.4)] hover:shadow-[0_20px_35px_-5px_rgba(185,28,28,0.5)] transition-all transform hover:-translate-y-1 inline-flex items-center gap-3 uppercase tracking-wider overflow-hidden w-full md:w-auto justify-center"
                >
                  <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]"></span>
                  <span className="relative flex items-center gap-3">
                    See If You Are A Fit <ArrowRight className="h-6 w-6 transition-transform duration-300 group-hover:translate-x-2" />
                  </span>
                </button>
                <div className="text-zinc-600 text-base md:text-lg mt-1 font-medium">
                  No pressure, just a conversation
                </div>
              </div>

              {/* TESTIMONIALS — native horizontal scroll strip, tap a video to play it */}
              <div className="w-full mt-16 mb-20">
                <div className="text-center mb-10 px-4">
                  <h2 className="text-3xl md:text-5xl font-extrabold text-zinc-950 tracking-tight">Don't take my word for it.</h2>
                  <p className="text-zinc-600 text-lg mt-4">Hear it from the women who've been through it.</p>
                  <p className="text-red-600 text-sm md:text-base mt-3 font-bold uppercase tracking-wide flex items-center justify-center gap-2">
                    <ChevronLeft className="w-4 h-4" /> Swipe across &amp; tap a video to play <ChevronRight className="w-4 h-4" />
                  </p>
                </div>

                <div
                  className="flex gap-5 px-5 overflow-x-auto hide-scrollbar snap-x snap-mandatory scroll-smooth"
                  style={{ WebkitOverflowScrolling: 'touch' }}
                >
                  {videoTestimonials.map((test, i) => (
                    <div
                      key={i}
                      id={`story-${i}`}
                      className="w-64 sm:w-72 shrink-0 snap-start bg-white rounded-3xl shadow-md border border-zinc-200 overflow-hidden flex flex-col text-left"
                    >
                      <div className="aspect-square bg-black relative overflow-hidden">
                        <BunnyVideo
                          libraryId={BUNNY_LIBRARY_ID}
                          videoId={test.bunnyId}
                          title={`Testimonial ${i + 1}`}
                          onCta={startQuiz}
                          onNext={i < videoTestimonials.length - 1 ? () => showNextStory(i) : undefined}
                          compact
                        />
                      </div>
                      <div className="p-4 text-center bg-white">
                        <div className="flex justify-center gap-0.5 text-amber-500 mb-2">
                          <Star className="h-3.5 w-3.5 fill-current" /><Star className="h-3.5 w-3.5 fill-current" /><Star className="h-3.5 w-3.5 fill-current" /><Star className="h-3.5 w-3.5 fill-current" /><Star className="h-3.5 w-3.5 fill-current" />
                        </div>
                        <p className="font-semibold text-zinc-700 text-xs leading-relaxed italic line-clamp-3">"{test.quote}"</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* LIVE ACTIVITY RIBBON — removed (fake-urgency ticker reduced trust) */}

              {/* THE WALL OF WINS — auto-scrolling marquee of real client screenshots */}
              <div className="w-full mb-16">
                <div className="text-center mb-8 px-4">
                  <h2 className="text-2xl md:text-4xl font-black text-zinc-950 uppercase tracking-tighter">
                    Real Women. Real Results.
                  </h2>
                  <p className="text-zinc-600 mt-2">Unfiltered screenshots from real clients.</p>
                </div>

                <div className="marquee-row relative overflow-hidden mb-4 [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]">
                  <div className="animate-marquee-left gap-5 pl-5">
                    {[...wallOfWinsRow1, ...wallOfWinsRow1].map((win, idx) => (
                      <div key={idx} className="w-64 shrink-0 bg-white p-3 rounded-2xl shadow-md border border-zinc-200">
                        <p className="text-xs font-semibold text-zinc-600 mb-2 px-1 line-clamp-2 h-8">{win.caption}</p>
                        <div className="rounded-xl overflow-hidden border border-zinc-200 bg-zinc-100 aspect-[4/5]">
                          <img src={win.image} alt={win.caption} className="w-full h-full object-contain" />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="marquee-row relative overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]">
                  <div className="animate-marquee-right gap-5 pl-5">
                    {[...wallOfWinsRow2, ...wallOfWinsRow2].map((win, idx) => (
                      <div key={idx} className="w-64 shrink-0 bg-white p-3 rounded-2xl shadow-md border border-zinc-200">
                        <p className="text-xs font-semibold text-zinc-600 mb-2 px-1 line-clamp-2 h-8">{win.caption}</p>
                        <div className="rounded-xl overflow-hidden border border-zinc-200 bg-zinc-100 aspect-[4/5]">
                          <img src={win.image} alt={win.caption} className="w-full h-full object-contain" />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="flex flex-col items-center justify-center gap-3 mt-10">
                <button
                  onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); setStep(1); }}
                  className="group relative bg-red-700 hover:bg-red-800 text-white text-xl md:text-2xl font-black py-6 px-12 rounded-md shadow-[0_10px_25px_-5px_rgba(185,28,28,0.4)] hover:shadow-[0_20px_35px_-5px_rgba(185,28,28,0.5)] transition-all transform hover:-translate-y-1 inline-flex items-center gap-3 uppercase tracking-wider overflow-hidden w-full md:w-auto justify-center"
                >
                  <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]"></span>
                  <span className="relative flex items-center gap-3">
                    See If You Are A Fit <ArrowRight className="h-6 w-6 transition-transform duration-300 group-hover:translate-x-2" />
                  </span>
                </button>
                <div className="text-zinc-600 text-base md:text-lg mt-1 font-medium">
                  No pressure, just a conversation
                </div>
              </div>

              <div className="flex items-center justify-center gap-3 mt-16">
                <span className="hidden sm:block h-px w-10 bg-zinc-300"></span>
                <p className="flex items-center gap-2 text-zinc-600 text-[11px] md:text-xs font-semibold uppercase tracking-[0.2em]">
                  <span className="text-amber-500 text-sm">★★★★★</span>
                  Trusted by 1000+ South Asians
                </p>
                <span className="hidden sm:block h-px w-10 bg-zinc-300"></span>
              </div>

              {/* POLAROID TESTIMONIALS */}
              <div className="flex flex-col sm:flex-row justify-center items-center gap-8 mt-16">
                <div className="bg-white p-3 pb-16 rounded-sm shadow-2xl max-w-[280px] -rotate-2 relative">
                  <img src="/polaroid-female-1.jpg" alt="Client testimonial" className="w-full rounded-sm" />
                  <p className="text-zinc-800 text-sm font-medium italic text-center px-2 mt-4 leading-snug" style={{ fontFamily: 'Georgia, serif' }}>
                    "This ended up costing me only £50 a month due to the amount of savings these guys got me, along with all the weight loss. So I actually saved more money working with them. And I lost the weight."
                  </p>
                </div>
                <div className="bg-white p-3 pb-16 rounded-sm shadow-2xl max-w-[280px] rotate-2 relative">
                  <img src="/polaroid-female-2.jpg" alt="Client testimonial" className="w-full rounded-sm" />
                  <p className="text-zinc-800 text-sm font-medium italic text-center px-2 mt-4 leading-snug" style={{ fontFamily: 'Georgia, serif' }}>
                    "I'm genuinely kicking myself for not joining sooner. The biggest regret I've got."
                  </p>
                </div>
              </div>
            </section>

            {/* WHAT'S INCLUDED — value-stack breakdown */}
            <section className="w-full max-w-6xl mx-auto px-4 mb-4 pt-4">
              <div className="text-center mb-4">
                <h2 className="text-3xl md:text-5xl font-black text-zinc-950 leading-tight mb-3">
                  Coaching Gives You Everything<br className="hidden md:block" /> You Need To Transform Your Body
                </h2>
                <p className="text-zinc-600 text-sm md:text-base">Based on the exact system I've used to help 500+ South Asian women lose weight for good.</p>
              </div>

              <div className="flex gap-5 px-1 py-10 overflow-x-auto hide-scrollbar snap-x snap-mandatory scroll-smooth">
                {[
                  "/icons3d/card-no-gym.jpg",
                  "/icons3d/card-nutrition.jpg",
                  "/icons3d/card-support.jpg",
                  "/icons3d/card-lifetime.jpg",
                ].map((src, i) => (
                  <div key={i} className="w-60 shrink-0 snap-start rounded-2xl overflow-hidden">
                    <img src={src} alt="" className="w-full h-auto object-contain" />
                  </div>
                ))}
              </div>
            </section>

            {/* THE INVESTMENT — single CTA lives here, right before Meet Your Coach */}
            <section className="w-full bg-zinc-100 border-t border-zinc-200 py-24 px-4">
              <div className="max-w-2xl mx-auto">
                <div className="flex items-center justify-center gap-3 mb-10">
                  <span className="hidden sm:block h-px w-10 bg-zinc-300"></span>
                  <p className="flex items-center gap-2 text-zinc-600 text-[11px] md:text-xs font-semibold uppercase tracking-[0.2em]">
                    <span className="text-amber-500 text-sm">★★★★★</span>
                    Trusted by 1000+ South Asians
                  </p>
                  <span className="hidden sm:block h-px w-10 bg-zinc-300"></span>
                </div>

                <div className="relative bg-black border-2 border-red-700 rounded-3xl px-6 md:px-14 py-14 mb-6 mx-1 overflow-hidden">
                  <span className="absolute -top-10 left-4 md:left-8 text-8xl md:text-9xl font-black text-red-700/30 leading-none select-none pointer-events-none" style={{ fontFamily: 'Georgia, serif' }}>"</span>
                  <p className="relative text-red-500 text-xs md:text-sm font-black uppercase tracking-[0.3em] mb-6 text-center">Money-Back Guarantee</p>
                  <p className="relative text-white text-2xl md:text-4xl font-black leading-tight text-center max-w-xl mx-auto">
                    Even though I know this works and I've got no business doing this, I still want you to have peace of mind.
                  </p>
                  <span className="absolute -bottom-20 right-4 md:right-8 text-8xl md:text-9xl font-black text-red-700/30 leading-none select-none pointer-events-none rotate-180" style={{ fontFamily: 'Georgia, serif' }}>"</span>
                </div>

                <div className="bg-white border border-zinc-200 shadow-sm rounded-2xl p-5 text-center mb-14">
                  <p className="text-zinc-700 text-sm md:text-base font-semibold">
                    Mounjaro costs <span className="text-zinc-950 font-black">£150–£350 a month</span> on its own.
                  </p>
                  <p className="text-zinc-600 text-sm mt-1">This costs less — and it works even after you stop.</p>
                </div>

                {/* MOUNJARO COST COUNTER — tap to open, drag to 12 months to reveal the message */}
                <div className="-mt-8 mb-14">
                  <MounjaroCounter onCta={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); setStep(1); }} />
                </div>

                <div className="mb-14">
                  <h2 className="text-3xl md:text-4xl font-black text-zinc-950 text-center mb-2">The Thing is......</h2>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 py-4">

                    <div className="relative bg-white border border-red-600/30 rounded-2xl p-3 shadow-[0_10px_30px_-10px_rgba(220,38,38,0.4)]">
                      <img src="/icons3d/pitch-book.jpg" alt="Zayb's book" className="w-full aspect-square object-cover rounded-xl" />
                      <p className="text-zinc-950 text-sm font-bold text-center mt-3">I've written the book</p>
                    </div>

                    <div className="relative bg-white border border-red-600/30 rounded-2xl p-3 shadow-[0_10px_30px_-10px_rgba(220,38,38,0.4)]">
                      <img src="/icons3d/pitch-youtube.jpg" alt="Free on YouTube" className="w-full aspect-square object-cover rounded-xl" />
                      <p className="text-zinc-950 text-sm font-bold text-center mt-3">I teach it for free on YouTube.</p>
                    </div>

                    <div className="relative bg-white border border-red-600/30 rounded-2xl p-3 shadow-[0_10px_30px_-10px_rgba(220,38,38,0.4)]">
                      <img src="/icons3d/pitch-guides.jpg" alt="Free guides" className="w-full aspect-square object-cover rounded-xl" />
                      <p className="text-zinc-950 text-sm font-bold text-center mt-3">I also have a tonne of free guides.</p>
                    </div>

                  </div>

                  <p className="text-3xl md:text-4xl font-black text-zinc-950 text-center px-4 mt-6">
                    But if you are ready to push things further, I want you to spend less on junk food and work with me.
                  </p>
                </div>

                <div className="flex flex-col items-center justify-center gap-3">
                  <button
                    onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); setStep(1); }}
                    className="group relative bg-red-700 hover:bg-red-800 text-white text-xl md:text-2xl font-black py-6 px-12 rounded-md shadow-[0_10px_25px_-5px_rgba(185,28,28,0.4)] hover:shadow-[0_20px_35px_-5px_rgba(185,28,28,0.5)] transition-all transform hover:-translate-y-1 inline-flex items-center gap-3 uppercase tracking-wider overflow-hidden w-full md:w-auto justify-center"
                  >
                    <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]"></span>
                    <span className="relative flex items-center gap-3">
                      See If You Are A Fit <ArrowRight className="h-6 w-6 transition-transform duration-300 group-hover:translate-x-2" />
                    </span>
                  </button>
                  <div className="text-zinc-600 text-base md:text-lg mt-3 font-medium">
                    No pressure, just a conversation
                  </div>
                </div>
              </div>
            </section>

            <section className="w-full bg-white py-24 px-4 text-zinc-950">
              <div className="max-w-5xl mx-auto text-center space-y-12">

                <div className="space-y-6">
                  <p className="text-red-600 font-black uppercase tracking-widest text-sm md:text-base">Meet Your Coach</p>
                  <h2 className="text-3xl md:text-5xl lg:text-6xl font-extrabold leading-tight tracking-tight">
                    Hi, I'm Zayb. <br className="hidden md:block" />
                    Real-World Experience. <br className="hidden md:block" />
                    No Fad Diets.
                  </h2>
                  <p className="text-zinc-600 text-lg md:text-xl max-w-3xl mx-auto font-medium leading-relaxed">
                    I'm not teaching ideas from a textbook. Everything you'll discover about building your body, scaling your energy, and future-proofing your health comes from hard-won, real-world experience helping hundreds of South Asian women transform.
                  </p>
                </div>

                <div className="max-w-md mx-auto pt-6">
                  <div className="rounded-2xl overflow-hidden shadow-2xl border border-zinc-200 aspect-[4/5] relative group">
                    <img
                      src="/coach-photo.jpg"
                      alt="Zayb — Founder of Z.A Training"
                      className="absolute inset-0 w-full h-full object-cover object-top grayscale group-hover:grayscale-0 transition-all duration-700 ease-in-out"
                    />
                  </div>
                  <p className="text-zinc-950 font-black text-xl md:text-2xl mt-6">Zayb</p>
                  <p className="text-zinc-600 font-bold text-sm uppercase tracking-widest mt-1">Founder &amp; Head Coach, Z.A Training</p>
                </div>

              </div>
            </section>


            {/* GOOGLE REVIEWS SECTION WITH FIXED COMPONENT RENDER */}
            <section className="w-full bg-zinc-100 py-24 px-4 border-t border-zinc-200">
              <div className="max-w-7xl mx-auto">
                <div className="flex flex-col items-center text-center mb-12">
                  <h2 className="text-3xl md:text-5xl font-extrabold text-zinc-950 tracking-tight mb-6">Real Results, Verified.</h2>
                  
                  <div className="flex flex-col md:flex-row items-center gap-4 bg-white px-8 py-4 rounded-2xl shadow-sm border border-zinc-200">
                    <div className="flex items-center gap-3">
                      <span className="text-5xl font-black text-zinc-950">5.0</span>
                      <div className="flex flex-col items-start">
                        <div className="flex gap-1 text-amber-500">
                          <Star className="h-5 w-5 fill-current" /><Star className="h-5 w-5 fill-current" /><Star className="h-5 w-5 fill-current" /><Star className="h-5 w-5 fill-current" /><Star className="h-5 w-5 fill-current" />
                        </div>
                        <span className="text-sm font-bold text-zinc-600 mt-1">Based on genuine Google Reviews</span>
                      </div>
                    </div>
                    <div className="hidden md:block w-px h-12 bg-zinc-300 mx-4"></div>
                    <div className="flex items-center gap-2 mt-4 md:mt-0">
                      <svg className="w-8 h-8" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                      </svg>
                      <span className="font-bold text-zinc-700 text-lg">Reviews</span>
                    </div>
                  </div>
                </div>

                <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
                  {googleReviewsData.map((review, i) => (
                    <GoogleReviewCard key={i} review={review} />
                  ))}
                </div>
              </div>
            </section>

            <div className="w-full bg-white border-t border-zinc-200 py-16 px-4 flex flex-col items-center justify-center gap-3">
              <button
                onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); setStep(1); }}
                className="group relative bg-red-700 hover:bg-red-800 text-white text-xl md:text-2xl font-black py-6 px-12 rounded-md shadow-[0_10px_25px_-5px_rgba(185,28,28,0.4)] hover:shadow-[0_20px_35px_-5px_rgba(185,28,28,0.5)] transition-all transform hover:-translate-y-1 inline-flex items-center gap-3 uppercase tracking-wider overflow-hidden w-full md:w-auto justify-center"
              >
                <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]"></span>
                <span className="relative flex items-center gap-3">
                  See If You Are A Fit <ArrowRight className="h-6 w-6 transition-transform duration-300 group-hover:translate-x-2" />
                </span>
              </button>
              <div className="text-zinc-600 text-base md:text-lg mt-1 font-medium">
                No pressure, just a conversation
              </div>
            </div>

            {/* PREMIUM FAQ SECTION */}
            <section id="glp1-faq" className="w-full bg-zinc-100 py-24 px-4 border-t border-zinc-200">
              <div className="max-w-3xl mx-auto">
                <div className="text-center mb-12">
                  <h2 className="text-3xl md:text-5xl font-extrabold text-zinc-950 tracking-tight">Frequently Asked Questions</h2>
                  <p className="text-zinc-600 text-lg mt-4 font-medium">Everything you need to know before applying.</p>
                </div>
                <div className="space-y-4">
                  {faqs.map((faq, idx) => (
                    <div key={idx} className="border border-zinc-200 rounded-2xl overflow-hidden shadow-sm bg-white transition-all">
                      <button 
                        onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
                        className="w-full text-left px-6 py-5 font-bold text-lg md:text-xl text-zinc-950 flex justify-between items-center bg-white hover:bg-zinc-50 transition-colors"
                      >
                        <span className="pr-4">{faq.q}</span>
                        <ChevronDown className={`w-6 h-6 text-red-600 shrink-0 transition-transform duration-300 ${openFaq === idx ? 'rotate-180' : ''}`} />
                      </button>
                      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openFaq === idx ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}>
                        <p className="p-6 text-zinc-600 text-lg leading-relaxed border-t border-zinc-200">
                          {faq.a}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            {/* LEGITIMACY FOOTER */}
            <footer className="bg-white text-zinc-600 py-12 px-4 text-center border-t border-zinc-200">
               <div className="max-w-4xl mx-auto flex flex-col items-center">
                 <div className="p-3 mb-6 inline-block">
                   <img 
                     src="https://firebasestorage.googleapis.com/v0/b/accountability-566c2.firebasestorage.app/o/088529ce-52f4-4ef7-a65f-0923d5901386.png?alt=media" 
                     alt="Z.A Training & Education Logo" 
                     className="h-10 md:h-12 object-contain block" 
                     onError={(e) => { e.currentTarget.style.display = 'none'; }}
                   />
                 </div>
                 <p className="font-bold text-zinc-700 mb-2">Z.A Training & Education</p>
                 <p className="text-sm mb-6 max-w-md">Empowering South Asians to build sustainable, lifelong health without sacrificing their culture.</p>
                 <div className="flex gap-6 text-xs uppercase tracking-widest font-bold">
                   <a href="https://www.zatraining.co.uk/terms" target="_blank" rel="noopener noreferrer" className="hover:text-zinc-700 transition-colors">Terms</a>
                   <a href="https://www.zatraining.co.uk/privacy" target="_blank" rel="noopener noreferrer" className="hover:text-zinc-700 transition-colors">Privacy</a>
                   <a href="https://www.zatraining.co.uk" target="_blank" rel="noopener noreferrer" className="hover:text-zinc-700 transition-colors">Contact</a>
                 </div>
                 <p className="text-xs mt-8 opacity-50">© {new Date().getFullYear()} Z.A Training. All rights reserved.</p>
               </div>
            </footer>

          </div>
        )}


        {/* ==========================================
            THE QUIZ FUNNEL (Steps 1 to 4)
            ========================================== */}
        {step > 0 && step <= 3 && (
          <div className="w-full max-w-3xl animate-in slide-in-from-right duration-500 mt-8 md:mt-12 px-4 mb-20 mx-auto">
            
            {/* ENHANCED PROGRESS BAR */}
            <div className="mb-8 bg-white p-6 rounded-2xl shadow-sm border border-zinc-200">
              <div className="flex justify-between items-end mb-3">
                <span className="bg-zinc-200 text-zinc-600 text-xs font-extrabold px-3 py-1.5 rounded-full uppercase tracking-wider">
                  Step {step} of 3
                </span>
                <span className="text-red-700 font-black text-sm">{Math.round((step / 3) * 100)}% Completed</span>
              </div>
              <div className="w-full bg-zinc-200 rounded-full h-3 overflow-hidden shadow-inner">
                <div className="bg-gradient-to-r from-red-600 to-red-500 h-full rounded-full transition-all duration-700 ease-out relative" style={{ width: `${(step / 3) * 100}%` }}>
                  <div className="absolute inset-0 bg-white/20 w-full h-full animate-[shimmer_2s_infinite]"></div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-3xl shadow-xl p-6 md:p-10 border border-zinc-200">
              
              {/* Helper function to render the new app-style option cards */}
              {(() => {
                const renderOption = (questionId: string, option: any, idx: number) => {
                  const isSelected = selectedAnswer === option.text;
                  const isDisabled = selectedAnswer !== null && !isSelected;
                  
                  return (
                    <button 
                      key={idx} 
                      onClick={() => handleAnswer(questionId, option.text)}
                      disabled={selectedAnswer !== null}
                      className={`relative w-full p-5 md:p-6 rounded-3xl border-2 transition-all duration-300 group flex flex-col sm:flex-row items-center sm:items-start gap-4 md:gap-5 
                        ${isSelected 
                          ? 'border-green-500 bg-green-50 scale-[0.98] shadow-inner' 
                          : isDisabled 
                            ? 'border-zinc-200 bg-zinc-100 opacity-50 grayscale'
                            : 'border-zinc-200 bg-white hover:border-red-500 hover:shadow-[0_10px_20px_-10px_rgba(220,38,38,0.25)] hover:-translate-y-1'
                        }`}
                    >
                      {/* Green Checkmark Overlay */}
                      {isSelected && (
                        <div className="absolute top-4 right-4 text-green-600 animate-in zoom-in duration-200">
                          <CheckCircle2 className="h-6 w-6 fill-green-100" />
                        </div>
                      )}
                      
                      {/* Icon Block */}
                      <div className={`p-4 rounded-2xl transition-colors duration-300 shrink-0
                        ${isSelected ? 'bg-green-100 text-green-600' : 'bg-zinc-100 text-zinc-600 group-hover:bg-red-100 group-hover:text-red-600'}`}>
                        {option.icon}
                      </div>
                      
                      {/* Text Block */}
                      <div className="text-center sm:text-left flex-1 pt-1 md:pt-2">
                        <span className={`font-bold text-lg md:text-xl leading-snug transition-colors ${
                          isSelected ? 'text-green-700' : 'text-zinc-800 group-hover:text-zinc-950'
                        }`}>
                          {option.text}
                        </span>
                      </div>
                    </button>
                  );
                };

                return (
                  <>
                    {/* QUESTION 1 */}
                    {step === 1 && (
                      <div className="animate-in fade-in zoom-in-95 duration-300">
                        <h2 className="text-3xl md:text-4xl font-extrabold mb-8 text-zinc-950 leading-tight text-center sm:text-left">
                          What's your main goal?
                        </h2>
                        <div className="space-y-4">
                          {[
                            { text: "Lose weight", icon: <Scale className="w-8 h-8" /> },
                            { text: "Get toned", icon: <Activity className="w-8 h-8" /> },
                            { text: "Both", icon: <Sparkles className="w-8 h-8" /> }
                          ].map((opt, i) => renderOption('goal', opt, i))}
                        </div>
                      </div>
                    )}

                    {/* QUESTION 2 */}
                    {step === 2 && (
                      <div className="animate-in slide-in-from-right duration-300">
                        <h2 className="text-3xl md:text-4xl font-extrabold mb-8 text-zinc-950 leading-tight text-center sm:text-left">What's stopped you before?</h2>
                        <div className="space-y-4">
                          {[
                            { text: "No time", icon: <Clock className="w-8 h-8" /> },
                            { text: "No consistency", icon: <TrendingDown className="w-8 h-8" /> },
                            { text: "Cultural food struggles", icon: <Utensils className="w-8 h-8" /> }
                          ].map((opt, i) => renderOption('barrier', opt, i))}
                        </div>
                      </div>
                    )}

                    {/* QUESTION 3 (Readiness / timeline) */}
                    {step === 3 && (
                      <div className="animate-in slide-in-from-right duration-300">
                        <h2 className="text-3xl md:text-4xl font-extrabold mb-8 text-zinc-950 leading-tight text-center sm:text-left">How soon do you want results?</h2>
                        <div className="space-y-4">
                          {[
                            { text: "ASAP", icon: <Flame className="w-8 h-8" /> },
                            { text: "A few months", icon: <CalendarCheck className="w-8 h-8" /> },
                            { text: "Not fast — I just need results", icon: <Heart className="w-8 h-8" /> }
                          ].map((opt, i) => renderOption('timeline', opt, i))}
                        </div>
                      </div>
                    )}

                  </>
                );
              })()}
            </div>
          </div>
        )}

        {/* ==========================================
            STEP 5: LOADING / ANALYZING SIMULATION
            ========================================== */}
        {step === 5 && (
          <div className="w-full max-w-lg text-center py-32 animate-in fade-in duration-300 px-4">
            <div className="relative w-32 h-32 mx-auto mb-8">
              <div className="absolute inset-0 border-4 border-zinc-200 rounded-full"></div>
              <div className="absolute inset-0 border-4 border-red-700 rounded-full border-t-transparent animate-spin"></div>
              <Search className="absolute inset-0 m-auto h-12 w-12 text-red-700 animate-pulse" />
            </div>
            <h2 className="text-3xl font-extrabold text-zinc-950 mb-4 transition-all duration-300">{loadingText}</h2>
            <div className="w-full bg-zinc-300 rounded-full h-2 max-w-xs mx-auto overflow-hidden">
               <div className="bg-red-700 h-full rounded-full animate-[progress_3s_ease-in-out_forwards]" style={{ width: '100%' }}></div>
               <style dangerouslySetInnerHTML={{__html: `
                  @keyframes progress {
                    0% { width: 0%; }
                    20% { width: 40%; }
                    60% { width: 70%; }
                    100% { width: 100%; }
                  }
               `}} />
            </div>
          </div>
        )}

        {/* ==========================================
            STEP 6: FINAL CAPTURE PAGE (Minimal)
            ========================================== */}
        {step === 6 && (
          <div className="w-full max-w-xl animate-in slide-in-from-bottom duration-500 mt-12 px-4 mb-20 mx-auto">
            <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 text-center border border-zinc-200">
              <h2 className="text-3xl font-extrabold text-zinc-950 leading-tight mb-2 tracking-tight">
                Let's Get Started
              </h2>
              <p className="text-zinc-600 font-bold mb-8 text-lg">
                Leave your details below and I will personally reach out.
              </p>

              <form onSubmit={finishApplication} className="space-y-4 max-w-sm mx-auto">
                <div className="text-left">
                  <input 
                    type="text" required placeholder="Your Full Name" value={name} onChange={(e) => setName(e.target.value)}
                    className="w-full px-5 py-4 rounded-xl border-2 border-zinc-300 focus:ring-0 focus:border-red-600 outline-none transition-all text-lg font-medium bg-white text-zinc-950 placeholder:text-zinc-400"
                  />
                </div>
                <div className="text-left">
                  <div className="relative">
                    <span className="absolute left-4 top-1/2 -translate-y-1/2 text-zinc-600 text-lg">📞</span>
                    <input 
                      type="tel" required placeholder="WhatsApp Number" value={phone} onChange={(e) => setPhone(e.target.value)}
                      className="w-full pl-12 pr-5 py-4 rounded-xl border-2 border-zinc-300 focus:ring-0 focus:border-red-600 outline-none transition-all text-lg font-medium bg-white text-zinc-950 placeholder:text-zinc-400"
                    />
                  </div>
                </div>

                <div className="pt-4 pb-2">
                  <div className="bg-red-50 border-2 border-red-600 rounded-xl px-5 py-4 shadow-sm flex items-start gap-3 text-left">
                    <span className="text-red-600 text-2xl md:text-3xl font-black leading-none shrink-0">!</span>
                    <p className="text-black text-sm md:text-base font-bold leading-snug">I'll message you on WhatsApp, build your free personal plan, and there's no pressure to join until you're ready.</p>
                  </div>
                </div>

                {submitError && <p className="text-red-600 text-sm font-bold text-center">Sorry, something went wrong sending your details. Please try again in a moment.</p>}

                <button type="submit" disabled={isSubmitting} className="w-full mt-2 bg-red-700 hover:bg-red-800 text-white font-black text-xl py-5 px-4 rounded-xl shadow-[0_10px_20px_-10px_rgba(220,38,38,0.5)] transition-all flex items-center justify-center gap-3 transform hover:-translate-y-1 uppercase tracking-wider relative overflow-hidden group disabled:opacity-50">
                  <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]"></span>
                  {isSubmitting ? (
                    <span className="relative z-10">Sending...</span>
                  ) : (
                    <span className="relative z-10 flex items-center justify-center gap-2 w-full">
                      <Lock className="h-6 w-6 shrink-0" strokeWidth={3} /> 
                      <span className="leading-tight text-center">Send My Enquiry</span>
                    </span>
                  )}
                </button>
              </form>
            </div>
          </div>
        )}

        {/* ==========================================
            STEP 7: FINAL VIDEO SUCCESS PAGE
            ========================================== */}
        {step === 7 && (
          <div className="min-h-screen w-full bg-white flex flex-col items-center pt-10 pb-20 px-4 animate-in fade-in duration-1000 overflow-hidden text-center">
             
             {/* Success Banner */}
             <div className="w-full max-w-2xl bg-green-50 border border-green-200 rounded-3xl shadow-xl p-8 md:p-10 mb-10 relative overflow-hidden">
                <div className="absolute top-0 left-0 w-full h-full opacity-20 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-green-300 via-green-50 to-green-50"></div>
                <div className="relative z-10">
                  <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                    <CheckCircle2 className="h-8 w-8" />
                  </div>
                  <h2 className="text-3xl md:text-4xl font-black mb-2 text-zinc-950 tracking-tight">Application Received.</h2>
                  <p className="text-zinc-700 text-lg font-medium">Keep an eye on your WhatsApp, <strong className="text-zinc-950">{name}</strong>. I'll be reaching out shortly.</p>
                </div>
             </div>

             {/* The 25 Second Video Area */}
             <div className="relative w-full max-w-2xl flex flex-col items-center mb-6 text-center">
               <div className="z-10">
                 <h2 className="text-2xl md:text-4xl font-black text-zinc-950 tracking-tight mb-2 leading-tight">Wait... quickly watch this before you go</h2>
                 <p className="text-lg md:text-2xl font-black text-red-600 uppercase tracking-[0.2em] italic mb-6">IT'S ONLY 25 SECONDS</p>
               </div>
               
               <div className="flex justify-center gap-16 md:gap-20 w-full mb-6">
                 <div className="text-red-600 w-12 h-12 md:w-16 md:h-16 transform -rotate-12 drop-shadow-lg">
                    <ArrowDown strokeWidth={3} className="w-full h-full" />
                 </div>
                 <div className="text-red-600 w-12 h-12 md:w-16 md:h-16 transform rotate-12 scale-x-[-1] drop-shadow-lg">
                    <ArrowDown strokeWidth={3} className="w-full h-full" />
                 </div>
               </div>
             </div>

             <div className="w-full max-w-[300px] md:max-w-sm aspect-[9/16] rounded-[2.5rem] bg-black shadow-[0_20px_50px_-10px_rgba(0,0,0,0.3)] overflow-hidden border-[8px] md:border-[12px] border-zinc-900 relative group mb-10">
                <BunnyVideo
                  libraryId={BUNNY_LIBRARY_ID}
                  videoId={BUNNY_VSL_VIDEO_ID}
                  title="Final Video"
                  onCta={startQuiz}
                  autoplay
                  showEndScreen={false}
                />
             </div>

             <p className="text-zinc-950 font-black text-lg md:text-xl uppercase tracking-tight px-4 mb-8 italic leading-tight max-w-lg">
               Please ensure you keep an eye out for your WhatsApp message from Coach Zayb.
             </p>

             <button onClick={resetFunnel} className="px-6 py-3 rounded-xl border-2 border-zinc-300 text-zinc-600 font-black uppercase tracking-widest text-[10px] hover:border-zinc-500 hover:text-zinc-900 transition-all flex items-center gap-2">
               <ChevronLeft size={14} /> Return to home page
             </button>
             
             <div className="mt-12 opacity-30">
               <img 
                 src="https://firebasestorage.googleapis.com/v0/b/accountability-566c2.firebasestorage.app/o/088529ce-52f4-4ef7-a65f-0923d5901386.png?alt=media" 
                 alt="Logo" 
                 className="h-8 grayscale mx-auto block" 
               />
             </div>
          </div>
        )}

        {/* ==========================================
            STEP 99: DISQUALIFIED (The Bouncer Kick-Out)
            ========================================== */}
        {step === 99 && (
          <div className="w-full max-w-2xl animate-in fade-in zoom-in-95 duration-500 mt-12 mb-20 px-4 mx-auto text-center">
            <div className="w-24 h-24 bg-zinc-200 text-zinc-600 rounded-full flex items-center justify-center mx-auto mb-8 shadow-inner">
              <X className="h-12 w-12" />
            </div>
            <h2 className="text-3xl md:text-5xl font-extrabold text-zinc-950 mb-6 tracking-tight">Sorry to hear you're not ready.</h2>
            <p className="text-zinc-600 text-xl font-medium leading-relaxed max-w-md mx-auto">
              Just come back when you are.
            </p>
          </div>
        )}

      </main>
      <Analytics />
    </div>
  );
}
